"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLinkedGXAnswerFields = exports.getUpdatedLinkedGXAnswers = exports.getGXDataForEHR = exports.formatGXDataForEHR = exports.mapGXKeyToEHRField = exports.getEHRBoundGXData = exports.formFieldsFromGxAnswers = void 0;
const transform_1 = __importDefault(require("lodash/transform"));
const merge_1 = __importDefault(require("lodash/merge"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const gx_1 = require("./constants/gx");
/**@summary Uses gx answers to populate fields in the patient form.
 * @description Processes data from the `visible` field from `linkedGxAnswers` but not the `hidden` field.
 * `visible` data is used to populate certain fields in the patientReg form.
 * If a user answers a DOB question from GX,
 * that data should be auto-filled when they get to the patientReg form.
 * This is done by linking answers from each to a `path` variable like `patient.dob` */
const formFieldsFromGxAnswers = (linkedGxAnswers) => {
    const { visible } = linkedGxAnswers;
    const fields = {};
    if (visible) {
        for (const key in visible) {
            fields[key] = {
                value: visible[key],
                errors: []
            };
        }
    }
    return fields;
};
exports.formFieldsFromGxAnswers = formFieldsFromGxAnswers;
/**GX questions-answers such as telehealth attestation may have a flag `sendToEHR: true`,
 * and this use case should be hidden from the consumer.
 * So these values will bypass registration form UI in DBW and
 * be passed as a field to Scheduling upon booking appointment.
 * @returns {Object} GX Data to be sent to EHR */
const getEHRBoundGXData = (linkedGxAnswers) => linkedGxAnswers.hidden || {};
exports.getEHRBoundGXData = getEHRBoundGXData;
const mapGXKeyToEHRField = (gxKey) => {
    const ehrSupportedGXQuestion = gx_1.EHR_SUPPORTED_GX_QUESTIONS.find((q) => q.name == gxKey);
    return (ehrSupportedGXQuestion === null || ehrSupportedGXQuestion === void 0 ? void 0 : ehrSupportedGXQuestion.ehrField) || gxKey;
};
exports.mapGXKeyToEHRField = mapGXKeyToEHRField;
/**@summary Formats GX Data to be sent to EHR.
 * @description There are character limits in the EHR appointment notes field,
 * so an answer value should be shortened to be respectful of resources.
 *     - Each EHR platform has different character limits.
 *     - For more, see: https://kyruus.jira.com/wiki/spaces/AHC/pages/331677967/How+To+Sending+Registration+Data+in+Appointment+Notes
 * @returns {Object} GX data formatted for EHR */
const formatGXDataForEHR = (gxData) => {
    const transformAnswerValues = (result, value, key) => {
        const shortenedYesNoAnswer = gx_1.YES_NO_ANSWERS.includes(value) && value.charAt(0);
        const updatedKey = (0, exports.mapGXKeyToEHRField)(key);
        result[updatedKey] = shortenedYesNoAnswer || value;
    };
    return (0, transform_1.default)(gxData, transformAnswerValues, {});
};
exports.formatGXDataForEHR = formatGXDataForEHR;
/**Gets EHR-bound GX questions, then processes for correct EHR formatting. */
const getGXDataForEHR = (linkedGxAnswers) => {
    const ehrBoundGXData = (0, exports.getEHRBoundGXData)(linkedGxAnswers);
    return (0, exports.formatGXDataForEHR)(ehrBoundGXData);
};
exports.getGXDataForEHR = getGXDataForEHR;
/**Immutably updates `linkedGxAnswers`. */
const getUpdatedLinkedGXAnswers = (steps, linkedGxAnswers) => {
    const linkedGxAnswersCopy = (0, cloneDeep_1.default)(linkedGxAnswers);
    const updatedLinkedGxAnswers = steps
        .map(exports.buildLinkedGXAnswerFields)
        .reduce((prev, cur) => {
        return (0, merge_1.default)(prev, cur);
    }, linkedGxAnswersCopy);
    return updatedLinkedGxAnswers;
};
exports.getUpdatedLinkedGXAnswers = getUpdatedLinkedGXAnswers;
/**@summary Builds `linkedGxAnswers` for a given GX `step`.
 * @description Sets the `hidden` field when given a `step` with property `sendToEHR: true`. Otherwise, the `visible` field will be set. */
const buildLinkedGXAnswerFields = (step) => {
    if (step === null || step === void 0 ? void 0 : step.sendToEHR)
        return setHiddenField(step);
    return setVisibleField(step);
};
exports.buildLinkedGXAnswerFields = buildLinkedGXAnswerFields;
/**Sets `hidden` field for `linkedGXAnswers` of a given GX `step`. */
const setHiddenField = (step) => ({
    hidden: {
        [step.name]: step.answer
    }
});
/**Sets `visible` field for `linkedGXAnswers` of a given GX `step`. */
const setVisibleField = (step) => {
    var _a;
    const isDOBQuestion = (_a = step === null || step === void 0 ? void 0 : step.control) === null || _a === void 0 ? void 0 : _a.path;
    if (isDOBQuestion) {
        const { answer, control } = step;
        const { path } = control;
        return {
            visible: {
                [path]: answer
            }
        };
    }
    return {};
};
//# sourceMappingURL=gxUtils.js.map